import { combineReducers } from "redux";
import * as type from "../../actions/action_types/action.types";
import { ERROR_OCCURED, POST_ERROR_OCCURED } from "../../actions/action_types/error.types";

const intitialState = {
  loading: false,
  sending: false,
  error: false,
  error_msg: null,
  data: null,
  board_data: null,
};

const getVisionReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.LOADING}_${type.GET_VISION}`:
      return {
        ...state,
        loading: true,
      };
    case type.GET_VISION:
      return {
        ...state,
        loading: false,
        data: action.payload.data.data,
      };
    case ERROR_OCCURED:
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const setVisionReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.SENDING}_${type.ADD_VISION}`:
      return {
        ...state,
        sending: true,
      };
    case type.ADD_VISION:
      return {
        ...state,
        sending: false,
        data: action.payload.data.data,
        success: action.payload.data.success,
      };
    case POST_ERROR_OCCURED:
      return {
        ...state,
        sending: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const getMissionReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.LOADING}_${type.GET_MISSION}`:
      return {
        ...state,
        loading: true,
      };
    case type.GET_MISSION:
      return {
        ...state,
        loading: false,
        data: action.payload.data.data,
      };
    case ERROR_OCCURED:
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const setMissionReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.SENDING}_${type.ADD_MISSION}`:
      return {
        ...state,
        sending: true,
      };
    case type.ADD_MISSION:
      return {
        ...state,
        sending: false,
        data: action.payload.data.data,
        success: action.payload.data.success,
      };
    case POST_ERROR_OCCURED:
      return {
        ...state,
        sending: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const getAboutGeneralReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.LOADING}_${type.GET_ABOUT_GEN}`:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ABOUT_GEN:
      return {
        ...state,
        loading: false,
        data: action.payload.data.data,
      };
    case ERROR_OCCURED:
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const setAboutGeneralReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.SENDING}_${type.ADD_ABOUT_GEN}`:
      return {
        ...state,
        sending: true,
      };
    case type.ADD_ABOUT_GEN:
      return {
        ...state,
        sending: false,
        data: action.payload.data.data,
        success: action.payload.data.success,
      };
    case POST_ERROR_OCCURED:
      return {
        ...state,
        sending: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const getMemberReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.LOADING}_${type.GET_MANAGEMNT_MEMBER}`:
      return {
        ...state,
        loading: true,
      };
    case `${type.LOADING}_${type.GET_BOARD_MEMBER}`:
      return {
        ...state,
        loading: true,
      };
    case type.GET_MANAGEMNT_MEMBER:
      return {
        ...state,
        loading: false,
        data: action.payload.data.data,
      };
    case type.GET_BOARD_MEMBER:
      return {
        ...state,
        loading: false,
        board_data: action.payload.data.data,
      };
    case ERROR_OCCURED:
      return {
        ...state,
        loading: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

const setMemberReducer = (state = intitialState, action) => {
  switch (action.type) {
    case `${type.SENDING}_${type.ADD_MEMBER}`:
      return {
        ...state,
        sending: true,
      };
    case type.ADD_MEMBER:
      return {
        ...state,
        sending: false,
        data: action.payload.data.data,
        success: action.payload.data.success,
      };
    case POST_ERROR_OCCURED:
      return {
        ...state,
        sending: false,
        error: true,
        error_msg: action.payload,
      };
    default:
      return state;
  }
};

export const aboutReducer = combineReducers({
  get_vision: getVisionReducer,
  set_vision: setVisionReducer,
  get_mission: getMissionReducer,
  set_mission: setMissionReducer,
  get_abt_gen: getAboutGeneralReducer,
  set_abt_gen: setAboutGeneralReducer,
  get_member: getMemberReducer,
  set_member: setMemberReducer,
});
